import { useContext, useEffect } from "react";
import { Button, Modal, Form, message, Select, Row, Col } from "antd";
import Moment from "react-moment";
import { AuthContext } from "../../../contexts/AuthContext";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleFetchAdvisors } from "../../../apis/users";
import { handleConfirmBooking } from "../../../apis/bookings";
const { Option } = Select;

export default function ConfirmBooking({
  isVisible,
  selected,
  setVisible,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { user } = useContext(AuthContext);

  const isAdvisor = user?.role?.name === "Service Advisor" ? true : false;

  const { data: users } = useQuery({
    queryKey: ["advisors"],
    queryFn: () => handleFetchAdvisors(),
  });

  const { mutate: confirmBooking } = useMutation({
    mutationFn: handleConfirmBooking,
    onSuccess: () => {
      message.success("Confirmed Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
      queryClient.invalidateQueries({ queryKey: ["allCount"] });
      queryClient.invalidateQueries({ queryKey: ["pendingCount"] });
      queryClient.invalidateQueries({ queryKey: ["confirmedCount"] });
      queryClient.invalidateQueries({ queryKey: ["fulfilledCount"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    let { assignedTo } = form.getFieldsValue();
    if (isAdvisor) {
      assignedTo = user?._id;
    }

    const data = {
      user: assignedTo,
    };
    await confirmBooking({ data, _id: selected._id });
  };

  const hideModal = () => {
    setVisible(false);
  };

  const userOptions = users?.records?.map((user: any, index: number) => (
    <Option value={user?._id} key={index}>
      {user?.name}
    </Option>
  ));

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title={`Confirm Booking #${selected?.bookingNo}`}
      onCancel={hideModal}
      footer={[
        <Button key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="confirmBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Confirm
        </Button>,
      ]}
      className="z-50"
    >
      <Form
        id="confirmBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="pb-2">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex text-black font-bold ">
            Customer: {selected?.name}
          </div>
          <div className="flex text-gray-600 mb-2">Driver: {selected?.driver}</div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.startTime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.endTime}</Moment>
          </div>
        </div>

        {isAdvisor ? null : (
          <div className="mb-8">
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                <Form.Item
                  name="assignedTo"
                  label="Assign To"
                  layout="vertical"
                  rules={[
                    {
                      required: true,
                      message: "Please select assignee",
                    },
                  ]}
                >
                  <Select placeholder="Assign To">{userOptions}</Select>
                </Form.Item>
              </Col>
            </Row>
          </div>
        )}
      </Form>
    </Modal>
  );
}
